export default __webpack_public_path__ + "static/media/3DView.b1eda85a.svg";